<template>
  <div :class="'customer-history-view wg-row com-anm22-app-inner-wrapper ' + (typeof license !== 'undefined' ? license.licenseHash : '')">
    <!-- TITLE -->
    <h1 class="com-anm22-page-title">
      {{ $anm22.strLang(lang, "Orders history", "Cronologia ordini") }}
    </h1>
    <!-- Orders -->
    <div class="wg-row" :style="{ height: listHeight + 'px'}">
      <w-g-list
        :loading="loading"
        :pagination="true"
        :fieldInit="'orderDate'"
        :keyField="'id'"
        :headerItems="headerItems"
        :itemsToDisplay="tableItems"
        :clickFn="openOrder"
      >
        <template v-slot:default="{ element, data }">
          <div class="wg-row item-row" style="padding-right: 3px">
            <div class="wg-col wg-xs-5 wg-sm-4">
              <div
                class="wg-row"
                style="
                  align-items: center;
                  flex-wrap: nowrap;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <div style="width: 20px; height: 20px; margin-right: 5px">
                  <world-object-icon
                    :type="'work'"
                    :obj="data.work"
                    :isImg="true"
                  >
                  </world-object-icon>
                </div>
                <div class="com-anm22-app-text-xl">
                  {{ data.work.name }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-none wg-sm-2">
              <div class="wg-row com-anm22-app-text-l">
                {{
                  $moment
                    .tz(element.orderDate, "X", timezone)
                    .format("DD-MM-YYYY HH:mm")
                }}
              </div>
            </div>
            <div class="wg-col wg-xs-5 wg-sm-3">
              <div
                class="wg-row com-anm22-app-text-l"
                :style="{
                  fontWeight: 'bold',
                  color: getStatusColor(element.status),
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }"
              >
                {{
                  $anm22.tableClasses
                    .foodOrderStatus()
                    .getById(element.status)[lang]
                }}
              </div>
            </div>
            <div class="wg-col wg-xs-none wg-sm-2">
              <div class="wg-row com-anm22-app-text-l">
                {{
                  element.estimatedTime ? element.estimatedTime + " min" : " "
                }}
              </div>
            </div>
            <div class="wg-col wg-xs-2 wg-sm-1">
              <div
                class="wg-row com-anm22-app-text-l"
                style="justify-content: flex-end"
              >
                {{ getAmount(element).toFixed(2) + " &euro;" }}
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import WGList from "../../../../../world/spa/components/WGList.vue";

export default {
  components: {
    "vue-simple-spinner": Spinner,
    WGList,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      licenseSelected: (state) => state.licenseSelected,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
      isOffline: (state) => state.offline.isOffline,
      appColor: (state) => state.config.appColor,
    }),
    listHeight() {
      return this.windowHeight - 160;
    },
    timezone() {
      return this.$moment.tz.guess(true);
    },
    orders() {
      return this.$store.getters["foodOrders/getByCustomer"](
        this.user.idWorldUser
      );
    },
    headerItems() {
      return [
        {
          field: "license",
          label: this.$anm22.strLang(this.lang, "Restaurant", "Ristorante"),
          class: "wg-xs-5 wg-sm-4",
          disabled: false,
        },
        {
          field: "orderDate",
          label: this.$anm22.strLang(this.lang, "Date", "Data"),
          class: "wg-xs-none wg-sm-2",
          disabled: false,
        },
        {
          field: "status",
          label: this.$anm22.strLang(this.lang, "Status", "Stato"),
          class: "wg-xs-5 wg-sm-3",
          disabled: false,
        },
        {
          field: "eta",
          label: this.$anm22.strLang(
            this.lang,
            "Estimated time",
            "Tempo stimato"
          ),
          class: "wg-xs-none wg-sm-2",
          disabled: true,
        },
        {
          field: "total",
          label: this.$anm22.strLang(this.lang, "Total", "Totale"),
          class: "wg-xs-2 wg-sm-1",
          style: { justifyContent: "flex-end" },
          disabled: true,
        },
      ];
    },
    tableItems() {
      return this.orders.map((o) => {
        const license = this.$store.getters["foodLicenses/get"](o.license);
        const work = this.$store.getters["works/get"](license.work);
        return {
          ...o,
          "list-metadata": {
            type: "item",
            work: work,
          },
        };
      });
    },
  },
  methods: {
    getAmount(order) {
      return order.toPayTotal + Number(order.payedTotal);
    },
    openOrder(order) {
      const license = this.$store.getters['foodLicenses/get'](order.license);
      if(!this.licenseSelected || this.licenseSelected !== license.licenseHash) {
        // Select this license
        this.$anm22.setCookie('com-anm22-food-license', license.licenseHash, 31536000);
        this.$anm22.setCookie('anm22_work', license.work, 31536000);
        this.$store.dispatch('setLicense', license.licenseHash);
      }
      this.$router.push("/orders/" + order.id).catch((e) => console.log(e));
    },
    getStatusColor(status) {
      switch (status) {
        case 1:
          return "#FF6D00";
        case 2:
          return "#BF360C";
        case 3:
          return "#FBC02D";
        case 4:
          return "#7CB342";
        case 5:
          return "#4FC3F7";
        case 6:
          return "#0091EA";
      }
    },
  },
  async created() {
    document.title = "YourFood";
    const response = await this.$http.get("customer/history");
    await Promise.all([
      this.$store.dispatch("foodLicenses/update", {
        vlf: this.$vlf("foodLicenses"),
        objs: response.data.licenses,
      }),
      this.$store.dispatch("works/update", {
        vlf: this.$vlf("works"),
        objs: response.data.works,
      }),
      this.$store.dispatch("foodOrders/update", {
        vlf: this.$vlf("foodOrders"),
        objs: response.data.orders,
        cleanFilters: [],
      }),
      this.$store.dispatch("foodOrderElements/update", {
        vlf: this.$vlf("foodOrderElements"),
        objs: response.data.orderElements,
        cleanFilters: [],
      }),
    ]);
    this.loading = false;
    this.$Progress.finish();
  },
};
</script>

<style lang="scss" scoped>
.item-row {
  height: 36px;
  padding: 10px 0;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
}
</style>